import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    QUOTE_POPUP_STATUS: false,
    QUANTITY_FIELD: [{'quantity': 0}],
    QUANTITY_FIELD_COUNT: 0
};
const slice = createSlice({
    name: "Quote",
    initialState: initialState,
    reducers: {
        SET_QUOTE_POPUP_STATUS: {
            reducer: (state, action) => {
                state.QUOTE_POPUP_STATUS = action.payload.QUOTE_POPUP_STATUS
            },
        },
        SET_QUANTITY_FIELD: {
            reducer: (state, action) => {
                state.QUANTITY_FIELD = action.payload.QUANTITY_FIELD
            },
        },
        SET_QUANTITY_FIELD_COUNT: {
            reducer: (state, action) => {
                state.QUANTITY_FIELD_COUNT = action.payload.QUANTITY_FIELD_COUNT
            },
        },
    }
})
    ;

export let { SET_QUOTE_POPUP_STATUS, SET_QUANTITY_FIELD, SET_QUANTITY_FIELD_COUNT } = slice.actions;

export default slice.reducer;
